import React from 'react';
import { useTranslation } from 'react-i18next';
import { usePopup } from '../contexts/PopupContext';
import ProfileInfoView from '../components/profile/ProfileInfoView';
import './ProfilePage.css';

function ProfilePage({ onLogout, onNavigateToMyEvents, onNavigateToDiscover }) {
  const { t } = useTranslation(['profile', 'shared']);
  const { openPopup } = usePopup();

  const handleOpenEdit = () => {
    openPopup('edit-profile', {}, 0);
  };

  const handleOpenSettings = () => {
    openPopup('settings', { onLogout }, 0);
  };

  return (
    <div className="profile-page">
      <div className="page-container">
        <header className="profile-header">
          <div>
            <h1>{t('profile.title')}</h1>
            <p className="page-subtitle">{t('profile.subtitle')}</p>
          </div>
        </header>

        <main className="profile-content">
          <ProfileInfoView
            onEdit={handleOpenEdit}
            onSettings={handleOpenSettings}
            onNavigateToMyEvents={onNavigateToMyEvents}
            onNavigateToDiscover={onNavigateToDiscover}
          />
        </main>
      </div>
    </div>
  );
}

export default ProfilePage;
